import React from 'react';

const WorkshopsIndex = React.lazy(() => import("./index"))
const NewWorkshops = React.lazy(() => import("./new"))
const EditWorkshops = React.lazy(() => import("./edit"))

export default[
	{path:'/workshops/:id/edit',component: EditWorkshops,name:'Edit Workshop'},
	{path:'/workshops/new',component: NewWorkshops,name:'New Workshop'},  
	{path:'/workshops',component: WorkshopsIndex,name:'Workshops'}, 
]

// import WorkshopsRoutes from "modules/workshops/web/routes"
// routes = _.concat(routes,WorkshopsRoutes)
